// API configuration
// For Discord Activities, you need to configure URL mappings in Discord Developer Portal
// to allow API calls to your backend
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export const API_ENDPOINTS = {
  // Legacy endpoints
  RANDOM_TEXTS: `${API_BASE_URL}/api/text/game/random-texts`,
  HEALTH: `${API_BASE_URL}/health`,

  // Daily game endpoints
  DAILY_GAME_TODAY: `${API_BASE_URL}/api/daily-game/today`,
  DAILY_GAME_RESULTS: `${API_BASE_URL}/api/daily-game/results`,
  DAILY_GAME_RESULTS_TODAY: `${API_BASE_URL}/api/daily-game/results/today`,
  DAILY_GAME_NEW_CONTENT: `${API_BASE_URL}/api/daily-game/new-content`,
  DAILY_GAME_SESSION: `${API_BASE_URL}/api/daily-game/session`,
  DAILY_AVERAGE_SCORE_TODAY: `${API_BASE_URL}/api/daily-game/average-score/today`,
  DAILY_AVERAGE_SCORE_PICTURE_TODAY: `${API_BASE_URL}/api/daily-game/average-score/today/picture`,

  // Game balance endpoints
  GAME_BALANCE: `${API_BASE_URL}/api/game-balance`,
  GAME_BALANCE_RELOAD: `${API_BASE_URL}/api/game-balance/reload`,

  // Game configuration endpoints
  GAME_CONFIG: `${API_BASE_URL}/api/game-config`,
  GAME_CONFIG_HISTORY: `${API_BASE_URL}/api/game-config/history`,
} as const;

export { API_BASE_URL };